import { css } from "@emotion/react";
import dayjs from "dayjs";
import { Link } from "react-router";
import { BookmarkButton } from "../../bits/bookmarks/BookmarkButton";
import {
  frjTagLink,
  frjArticleTitle,
  frjArticleExcerpt,
  frjArticleDate,
  frjArticleAuthor,
} from "../../bits/frjUtils";

type Post = {
  title?: string;
  published_at?: string | null;
  primary_author?: { name?: string } | null;
  excerpt?: string | null;
  slug: string;
  tags?: { name?: string; id: string; slug: string }[];
};

export const ArticleCard = ({
  post,
  tagSlug,
}: {
  post: Post;
  tagSlug?: string;
}) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 16px 0;
        border-bottom: 1px solid rgba(0, 31, 43, 0.1);
        &:last-child {
          border-bottom: none;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        `}
      >
        {post.tags?.map((tag) => {
          if (!tag.name) return null;
          if (tag.name.startsWith("#")) return null;
          return (
            <Link key={tag.id} to={`/frj/tag/${tag.slug}`} css={frjTagLink}>
              {tag.name}
            </Link>
          );
        })}
      </div>
      <Link
        to={`/${tagSlug === "issues" ? "frj/issue" : "article"}/${post.slug}`}
        css={css`
          text-decoration: none;
          transition: opacity 0.15s ease;
          &:hover {
            opacity: 0.8;
          }
        `}
      >
        <h3
          css={[
            frjArticleTitle,
            css`
              margin: 0 0 4px;
            `,
          ]}
        >
          {post.title}
        </h3>
        {post.excerpt && (
          <p
            css={[
              frjArticleExcerpt,
              css`
                margin: 0;
              `,
            ]}
          >
            {post.excerpt}
          </p>
        )}
      </Link>
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          {post.published_at && (
            <time
              dateTime={dayjs(post.published_at).format("YYYY-MM-DD")}
              css={frjArticleDate}
            >
              {dayjs(post.published_at).format("DD MMM YYYY")}
            </time>
          )}
          {post.primary_author?.name && (
            <span css={frjArticleAuthor}>{post.primary_author.name}</span>
          )}
        </div>
        <BookmarkButton
          sectionId={`${post.slug}-ch:0`}
          articleSlug={post.slug}
          sectionLabel={post.title ?? ""}
          contents={[{ id: "123", type: "chapter", label: post.title ?? "" }]}
        />
      </div>
    </div>
  );
};
